<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <flyer-produtos-cards />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import FlyerProdutosCards from "./components/FlyerProdutosCards.vue";

export default {
  name: "FlyerProdutos",
  components: {
    AuthenticatedLayout,
    FlyerProdutosCards,
  },
};
</script>
